<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                <div class="padding">
                    <h1 class="h2">Powiadomienia</h1>
                    <div v-if="getNotifications.length">
                        <div v-for="(item, index) in getNotifications" :key="index">
                            <item-notification
                                    :slug="item.slug"
                                    :title="item.title"
                                    :content="item.content"
                                    :thumbnail="item.thumbnail"
                                    :isRead="item.isRead"
                                    :redirect="item.url">
                            </item-notification>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-center">Brak powiadomień</p>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ItemNotification from '../../items/ItemNotification'
    import api from "@/services/Api";
    import Badge from '@/services/Badge';

    export default {
        name: 'UserNotifications',
        components: { ItemNotification },
        computed: {
            ...mapGetters(['getNotifications', 'showBadgeNotifications'])
        },
        mounted () {
            this.hideBadgeNotifications()
        },
        methods: {
            hideBadgeNotifications () {
                if (this.showBadgeNotifications) {
                    api.post('/api/v1/notifications/hide-badge').then(response => {
                        if(response.status === 200){
                            this.$store.commit('USER_SET_BADGE_NOTIFICATIONS', false)
                            Badge.clearBadge()
                        }
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .h2{
        margin-bottom: 1.5rem;
    }

</style>